import {
  EmployeeCustomTablesResourceValueFragment,
  EmployeeCustomTablesSchemaFieldFragment,
} from 'generated/resources/graphql'

import { dateBackendToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

const NOT_AVAILABLE = '-'
interface Props {
  schemaEffectiveAtId?: number | null
  field?: EmployeeCustomTablesSchemaFieldFragment | null
  resourceValue?: EmployeeCustomTablesResourceValueFragment
  notAvailable?: string
  companyLocale: string
  currency: string
}

export const getValue = ({
  schemaEffectiveAtId,
  field,
  resourceValue,
  notAvailable = NOT_AVAILABLE,
  companyLocale,
  currency,
}: Props): string => {
  if (!field) return notAvailable
  if (!resourceValue) {
    return notAvailable
  }

  const customValue = resourceValue.customValues.find((cv) => cv.fieldId === field.id)

  if (!customValue) return notAvailable

  if (schemaEffectiveAtId === field.id || field.fieldType === 'date') {
    return customValue.dateValue ? dateBackendToUI(customValue.dateValue) : '-'
  }

  if (field.fieldType === 'multiple_choice' || field.fieldType === 'single_choice') {
    const options: string[] = field.options.map((item) => item.label).filter(Boolean)
    const selectedOption =
      field.fieldType === 'multiple_choice'
        ? customValue.multipleChoiceValue
        : customValue.singleChoiceValue
    const values = options.filter((item) => String(selectedOption) == item)

    return values.join(', ')
  }

  if (field.fieldType === 'checkbox') {
    return !customValue.booleanValue
      ? i18n.t('custom_resources.basic.no')
      : i18n.t('custom_resources.basic.yes')
  }

  if (field.fieldType === 'cents') {
    return (Number(customValue.centsValue) / 100).toString()
  }

  if (field.fieldType === 'money') {
    return MoneyWithCurrency({
      amount: Number(customValue.numberValue),
      currency,
      locale: companyLocale,
    })
  }

  if (field.fieldType === 'rating') {
    return customValue.numberValue?.toString() ?? '-'
  }

  return customValue.longTextValue ?? '-'
}
